import EventBaseData from "@/components/Events/EventBaseData/EventBaseData.vue";
import EventDescription from "@/components/Events/EventDescription/EventDescription.vue";
import EventDates from "@/components/Events/EventDates/EventDates.vue";
import EventPrices from "@/components/Events/EventPrices/EventPrices.vue";
import EventInfos from "@/components/Events/EventInfos/EventInfos.vue";
import EventMedia from "@/components/Events/EventMedia/EventMedia.vue";
import EventConnections from "@/components/Events/EventConnections/EventConnections.vue";
import EventInstructions from "@/components/Events/EventInstructions/EventInstructions.vue";
import EventProcessingStatus from "@/components/Events/EventProcessingStatus/EventProcessingStatus.vue";
import License from "@/components/Common/License/License.vue";
import ChannelSelection from "@/components/Events/ChannelSelection/ChannelSelection.vue";
import "./EventEditDialog.scss";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import {
  getObjectDiff,
  getThirdPartySystem,
  isEmptyValue,
  getPrincipalName,
  getIsOwnedBySubPrincipalWarningHTML,
  onCKEditorReady
} from "@/helpers/commonHelper";
import { imports } from "@/helpers/eventHelper";

export default {
  name: "EventEditDialog",
  props: [
    "config",
    "editedEvent",
    "showDialog",
    "getOrganizer",
    "getLocation",
    "categoryGroups",
    "organizer",
    "locations",
    "features",
    "featureGroups",
    "users",
    "groupedOrganizer",
    "groupedLocations",
    "eventLoading",
    "eventLoadingDelayed",
    "momentsLoading"
  ],
  data: () => ({
    step: 1,
    validStepsForOwnedBySubPrincipal: [2, 5],
    isValid: false,
    errorList: [],
    errorDialog: false,
    initialEvent: {},
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js"
  }),
  components: {
    ValidationDialog,
    EventBaseData,
    EventDescription,
    EventDates,
    EventPrices,
    EventInfos,
    EventMedia,
    License,
    EventConnections,
    EventInstructions,
    EventProcessingStatus,
    ChannelSelection
  },
  async mounted() {
    if (this.config.useHighlightFrom === "own") {
      this.validStepsForOwnedBySubPrincipal.unshift(1);
    }
  },
  methods: {
    getThirdPartySystem,
    getObjectDiff,
    isEmptyValue,
    getPrincipalName,
    getIsOwnedBySubPrincipalWarningHTML,
    onCKEditorReady,
    cancelEdit() {
      this.dialog = false;
      window.location.href = "/events/events";
    },
    isValidStepForOwnedBySubPrincipal(value) {
      if (!this.isOwnedBySubPrincipal) {
        return true;
      }
      return this.validStepsForOwnedBySubPrincipal.includes(value);
    },
    changeStep(value) {
      this.errorDialog = false;
      this.step = value;
    },
    checkValid() {
      const form = this.$refs.eventEditForm;
      form.validate();
      const invalidFields = form._data.inputs.filter(i => !i.valid);
      this.errorList = [];
      invalidFields.forEach(field => {
        this.errorList.push({
          field: field?.$vnode?.componentOptions?.propsData?.label?.replace(
            "*",
            ""
          ),
          validations: field.validations
        });
      });
      if (!this.editedEvent.start)
        this.errorList.push({
          field: "Termine",
          validations: ["Bitte füllen Sie die Pflichtangaben aus!"]
        });
      if (this.errorList.length) this.errorDialog = true;

      if (this.errorList.length === 0) {
        return true;
      }
      return false;
    },
    isOwnChannel(channelValue) {
      return this.config.own_channels?.find(
        channel => channel.value === channelValue
      );
    },
    normalizeContentObj(obj) {
      const _obj = { ...obj };
      for (const key of Object.keys(_obj)) {
        delete _obj[key]._id;

        if (!_obj[key].description) {
          _obj[key].description = "";
        }
        if (!_obj[key].short_description) {
          _obj[key].short_description = "";
        }
      }
      return _obj;
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    activeImports() {
      return imports
        .filter(_ => _.isActive(this.currentPrincipal))
        .map(_ => _.typeId);
    },
    thirdPartySystems() {
      const typeIds = [];
      if (
        this.editedEvent.feratel_id &&
        this.activeImports.includes("Feratel-ID")
      ) {
        typeIds.push("Feratel-ID");
      }
      if (
        this.editedEvent.tramino_id &&
        this.activeImports.includes("Tramino-ID-Tourismus")
      ) {
        typeIds.push("Tramino-ID-Tourismus");
      }
      if (
        this.editedEvent.destination_one_id &&
        this.activeImports.includes("DestinationOne-ID")
      ) {
        typeIds.push("DestinationOne-ID");
      }
      if (
        this.editedEvent.eventim_id &&
        this.activeImports.includes("Eventim-ID")
      ) {
        typeIds.push("Eventim-ID");
      }

      return this.getThirdPartySystem(typeIds, "Events");
    },
    isOwnedBySubPrincipal() {
      if (!this.editedEvent.principal_id?.length) {
        return false;
      }
      return this.editedEvent.principal_id !== this.currentPrincipal?.id;
    },
    channels() {
      const standardChannels = this.config.standard_channels ?? [];
      const ownChannels = this.config.own_channels ?? [];
      const channels = standardChannels?.concat(ownChannels);
      return channels?.filter(c => this.config?.channels?.includes(c.value));
    },
    hideChannelSelection() {
      return this.config?.channels?.join("") === "web"; // only web-channel => hide
    },
    ownFeatureGroups() {
      return (
        this.featureGroups?.filter(
          featureGroup => featureGroup.owner === this.currentPrincipal?.id
        ) ?? []
      );
    },
    ownFeatures() {
      return this.ownFeatureGroups
        .map(featureGroup => featureGroup.features)
        .flat()
        .map(feature => feature._id);
    },
    dialog: {
      get() {
        return this.showDialog;
      },
      set(value) {
        this.errorDialog = false;
        this.errorList = false;
        if (!value) {
          this.step = 1;
          this.$emit("toggleEditDialog", value);
        }
      }
    },
    formTitle() {
      return this.editedEvent?.title
        ? `Veranstaltung "${this.editedEvent.title}" bearbeiten`
        : "Neue Veranstaltung erstellen";
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    isOwnedBySubPrincipalWarningHTML() {
      const principalName = this.getPrincipalName(
        this.editedEvent.principal_id
      );
      return this.getIsOwnedBySubPrincipalWarningHTML(principalName);
    }
  },
  watch: {
    dialog(newValue) {
      delete window._ckeditorReady;

      if (newValue && this.isOwnedBySubPrincipal) {
        const firstValidStep = this.validStepsForOwnedBySubPrincipal[0];
        this.changeStep(firstValidStep);
      } else if (!this.isOwnedBySubPrincipal) {
        return;
      }

      if (newValue) {
        const interval = setInterval(() => {
          if (this.initialEvent?._id !== this.editedEvent?._id)
            this.initialEvent = window.structuredClone(this.editedEvent);
          if (!window._ckeditorReady) {
            return;
          }
          clearInterval(interval);
        }, 1000);
      }
    }
  }
};
